// extracted by mini-css-extract-plugin
export var active = "index-module--active--FJicK";
export var block = "index-module--block--NT4Rq";
export var coverBottom = "index-module--coverBottom--a3awH";
export var coverTop = "index-module--coverTop--Pyduu";
export var crossOne = "index-module--crossOne--SYrGQ";
export var crossTwo = "index-module--crossTwo--cE5+C";
export var fill = "index-module--fill--JQ2HA";
export var move = "index-module--move--p+rOj";
export var title = "index-module--title--MkXLw";